import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Importaciones de módulos.
import { ActivationSettingsModule } from './activation-settings/activation-settings.module';
import { EmployeeSettingsModule } from './employee-settings/employee-settings.module';
import { FooterModule } from '../../components/footer/footer.module';
import { GeneralSettingsModule } from './general-settings/general-settings.module';
import { HeaderModule } from '../../components/header/header.module';
import { HostSettingsModule } from './host-settings/host-settings.module';
import { LicenseSettingsModule } from './license-settings/license-settings.module';
import { LogsSettingsModule } from './logs-settings/logs-settings.module';
import { PasswordSettingsModule } from './password-settings/password-settings.module';
import { ProductSettingsModule } from './product-settings/product-settings.module';
import { ProfileSettingsModule } from './profile-settings/profile-settings.module';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

// Importaciones de componentes.
import { SettingsComponent } from './settings.component';

@NgModule({
  declarations: [SettingsComponent],
  imports: [
    CommonModule,
    RouterModule,
    HeaderModule,
    FooterModule,
    ProfileSettingsModule,
    PasswordSettingsModule,
    ActivationSettingsModule,
    EmployeeSettingsModule,
    ProductSettingsModule,
    LicenseSettingsModule,
    HostSettingsModule,
    GeneralSettingsModule,
    LogsSettingsModule,
    MatIconModule,
  ],
})
export class SettingsModule {}
